import Mock from 'mockjs';
import { builder } from '../builder';

const Content = [
	{
		id: 21,
		content: `<p>
    客维智能科技（广州）有限公司注册资本5800万（下称客维）是国内卓越的创新型整合营销服务机构，2012年11月1日在广州股权交易中心（OTC版）挂
    牌公司，股票代码：890087。也是一家高新技术企业，客维以品牌带动营销的服务理念服务于我们的500强企业，客维整合各类一线品牌资源，为企业提供
    促销品订制、积分综合服务、电商代运营、员工福利等科技公司，定位为客户提供客户维护、客户关怀一站式解决方案，同时为消费者提供积分回馈、打折、
    通用的便民服务。<br /><br />

    公司拥有1065万C端客户群体，客维专注服务消费需求方和产品服务提供方，为各大企业单位提供定点消费代理服务， 包括积分推广、促销品和促销活
    动、电商代运营、员工福利、等行业解决方案；行业客户包括：金融、通讯、石油、航空、房地产等大型积分机构提供管理和提升客户忠诚的专业服务。<br /><br />

    客维旗下包括“客维.乐送商城”、 “客维.积分兑换服务”、“客维.促销品订制”、 “ 客维.手机通”、 “客维.乐送卡”、“手机广 告”、 “客维
    .礼品册”、“客维.易票通” 、“客维.电影通票”等业务，作为金牌产品推出给我们的优质客户，为我们的客户提供多元化通用服务。在此产品上，我们严
    格挑选供应商，选择知名度高、实力雄厚、品牌商家、明星企业作为我们的合作伙伴。<br /><br />

    客维以整合营销提升竞争优势，为客户的市场活动提供全面的系统解决方案。以创新设计、采购管理与市场终端服务体系作为三大重点，以营销策划、
    物料销售为主营业务，带动整合营销传播、体验营销设计和市场终端执行等全方位专业服务。客维总部位于广州，在北京、上海、深圳、长沙等城市设有分
    公司或项目组，服务网络遍及全国，辐射港澳。<br /><br />

    公司以人才为强司战略，汇集创意研发、市场营销、品牌战略、采购管理、物流规划、国际贸易等相关领域资深精英。</p>
    <div class="image">
    <div>
      <img src="https://api.keweizx.com/uploads/KEWEI/2022/08/31/825dc1c1cd8412312ba4aef1d54a7152.png" alt="">
      <p>公司环境1</p>
    </div>
    <div>
      <img src="https://api.keweizx.com/uploads/KEWEI/2022/08/31/428a47e5322f7480be74a01cb2305f57.png" alt="">
      <p>公司环境1</p>
    </div>
   </div>`,
		date: '',
		title: '客维智能科技（广州）有限公司简介',
		issued: '',
	},
	{
		id: 23,
		content: `顶级大牌坐镇 客维旗下产品定制，积分业务、乐送商务册，公司坚持采用国际顶级品牌作为服务企业客户的首选。着重于凝聚品牌力量，为客户企业营销如虎添翼。 
    
    从品牌工厂，分销商，国内和国际柜台等正规渠道购买的DIY私人定制业务在客维已有多年历史，具有丰富的产品开发经验，优质的工厂资源和原始的大品牌：乐送甄选、欧德乐Odell、比佛斯特Bifrost、天工坊Craf、半味长，客维甄选宣称与领先的品牌制造商新源与新秀丽、MUJI、WMF、MINISO、CK Home、Hugo Boss、Coach、MK、PRADA、魔膳师、飞利浦合作，并由品牌制造商直供优质产品。所有供应商都严格审核公司的资格，以确认供应商的品牌授权认可资格。 
    客维与国际顶级品牌紧密合作，签署了战略采购协议，私人定制，定制承销和其他产品解决方案，与柜台和大型购物中心一样，可以低成本批量购买，并且可以直接减少商店费用和人力成本等。确保产品销售的成本和价格是便宜的。客维服务的客户着重于品牌商品和包装，同时为企业提供专业的服务和设计，增加产品定制，logo元素，促销活动等相关公司元素，为企业提供一站式促销品解决方案。
    `,
		date: '',
		title: '',
		issued: '',
	},
	{
		id: 25,
		content: `<h2>品质优选，首先客维--客维乐送商城
    一家专门做企业品牌产品的网站
     乐送商城（www.4006088183.com）客维旗下品牌，满足消费者对易票通、商务册、臻萃券系列、乐送卡的需求，品牌客户可以提供在线消费平台，通过更多优质的选择，更方便的交流，更自主的购物，不用出门即可获得更多物美价廉的产品。 
    乐送商城不断创新和更新，为客户寻找高质量和低成本的产品，解决了日长忙碌、无法到店面消费的问题，为大客户提供了更实惠和便捷的消费平台。<br/> 
    客户所需，我们所想！<br/>
    宗旨：为您提供满意的售前，售中，售后服务  <br/>
    使命：为您稳住客户关系，提升员工满意度<br/>
    价值观：整合创造财富，携手共建辉煌<br/>
    <h2/>
    `,
		dete: '',
		title: '',
		issued: '',
	},
	{
		id: 26,
		content: `
    <h2>
    2008年9月，公司创办前期市场调研、资金募集。<br/><br/>
    2009年7月，广州金额为商务有限公司工商注册正式成立。<br/><br/>
    2009年12月，创立客维乐送商城。<br/><br/>
    2010年12月，获得中华人民共和国增值业务ICP经营许可证。<br/><br/>
    2012年11月，广州市客维商务服务有限公司在广州市股权交易中心（OTC版）挂牌上市，股票代码：890087。<br/><br/>
    2013年3月，获得12年度广东省诚信示范企业。<br/><br/>
    2014年11月，ISO9001-2008质量管理体系认证。<br/><br/>
    2012-2015年。获得15项软件专利著作权。<br/><br/>
    2016年12月，获得国家级高新技术企业称号。<br/><br/>
    2017年8月，获得第六届中国创新创业大赛（广州赛区）晋级省区大赛奖。<br/><br/>
    2017年9月，获得第六届中国创新创业大赛（广东赛区）成长组互联网与移动互联网行业优胜奖。<br/><br/>
    2017年10月，获得第三届“华炬杯”粤东西北创业大赛正式赛奖。<br/><br/>
    2017年10月，获得第六届中国创新创业大赛行业总决赛入围奖。<br/><br/>
    2017年11月，获得2017首届广州女性创客（创新创业）大赛三等奖。<br/><br/>
    2018年，企业申请接近200项软件专利著作权。
    <h2/>
    `,
	},
];

function params(str) {
	const a = str.split('&');
	const params = {};
	for (let i = 0; i < a.length; i++) {
		const d = a[i].split('=');
		params[d[0]] = d[1];
	}
	return params;
}

const getContent = (config) => {
	const data = params(config.body);
	const text = Content.find((item) => {
		if (Number(item.id) === Number(data.id)) {
			return item;
		}
	});

	if (text === undefined) {
		return builder({
			dete: '',
			title: '',
			issued: '',
			content: '',
		});
	}
	return builder(text);
};

Mock.mock('/api/get-Content', 'get', getContent);
